"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ADD_TO_MY_LIST_QUERY = "mutation AddToMyList($titleId: ID!) {\n  addToMyList(id: $titleId)\n}";
exports.default = ADD_TO_MY_LIST_QUERY;
//# sourceMappingURL=addTitleBookmark.js.map